export const validateUrlNoHttp = (url: string) => {
  const reg = new RegExp(
    // eslint-disable-next-line
    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,18}(:[0-9]{1,5})?(\/.*)?$/
  );

  return !!url.match(reg);
};
